import React from "react";
import styled from "styled-components";
import { Star } from "lucide-react";

const BadgeWrapper = styled.div`
  width: ${(p) => p.$size || 40}px;
  height: ${(p) => p.$size || 40}px;
  border-radius: 9999px;
  margin-bottom: ${(p) => (p.$mb === undefined ? 12 : p.$mb)}px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #F4EBFF; /* Brand/100 */
  border: ${(p) => p.$border || 6}px solid #F9F5FF; /* Brand/50 */
  color: #7F56D9; /* Brand/600 icon color */
`;

const StarBadge = ({ size = 40, border = 6, iconSize = 20, marginBottom = 0, className, style }) => {
  return (
    <BadgeWrapper className={className} style={style} $size={size} $border={border} $mb={marginBottom}>
      <Star size={iconSize} strokeWidth={2} />
    </BadgeWrapper>
  );
};

export default StarBadge;

